import { Card, Loading, PaginationData } from "components"
import { Fragment, useState } from "react"
import { useGetListRefundItem } from "./hooks"
import { TableListRefundItem } from "./components"
import { FilterDataType } from "./types"
import { FilterRefundItem } from "./components/filter-refund-item"

export const RefundItemListPage = () => {
  const [filterData, setFilterData] = useState<FilterDataType>({ 
    date_from: "",
    date_end: "",
    location_id: "",
    return_item_id: "",
    approval: "",
    search: "",
    total: 0,
    page: 0,
    limit: 10,
    pages: 0,
    keyword: ""
  })
  const getDataRefundItem = useGetListRefundItem(filterData)

  return (
    <Fragment>
      <section className="mt-2">
        <Card>
          <Card.Body>
            <FilterRefundItem selected={filterData} setSelected={setFilterData} />
          </Card.Body>
        </Card>
      </section>

      {getDataRefundItem?.isLoading ? (
        <Card className="mt-2">
          <Card.Body>
            <div className="flex justify-center py-12">
              <Loading loading />
            </div>
          </Card.Body>
        </Card>
      ) : (
        <section className="mt-2">
          <Card>
            <Card.Body>
              <TableListRefundItem
                data={getDataRefundItem?.data?.payload}
                isLoading={getDataRefundItem?.isLoading}
                refetch={getDataRefundItem.refetch}
              />

              <div className="mt-5">
                <PaginationData
                  data={getDataRefundItem?.data}
                  pagination={filterData}
                  setPagination={setFilterData}
                />
              </div>
            </Card.Body>
          </Card>
        </section>
      )}
    </Fragment>
  )
}
